import React, { useState } from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const FaQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How is Shubh Paisa different from other loan companies?",
      answer:
        "Shubh Paisa provides transparent loan services with instant approval, minimal documentation, and flexible repayment options—without hidden charges or unnecessary delays.",
    },

    {
      question: "Who can apply for a loan through Shubh Paisa?",
      answer:
        "Anyone with a valid ID proof and a steady income source can apply. Salaried professionals, self-employed individuals, small business owners—all are eligible.",
    },

    {
      question:
        "Can I apply for a Shubh Paisa loan without visiting any physical branch?",
      answer:
        "Yes! Shubh Paisa is a completely online process. You can apply, upload documents, verify, and receive loan approval directly from your phone.",
    },

    {
      question: "How fast can I get loan approval?",
      answer:
        "In most cases, loan approval happens within minutes after basic verification. Disbursal time depends on bank validation but is usually quick and hassle-free.",
    },

    {
      question: "Does Shubh Paisa charge any hidden fees?",
      answer:
        "No. All charges are transparent and mentioned upfront. No surprise fees, no hidden deductions.",
    },

    {
      question: "What is the minimum and maximum loan amount I can apply for?",
      answer:
        "You can apply for small personal loans as well as higher loan amounts based on eligibility, income profile, and document verification.",
    },

    {
      question: "What documents are required for loan approval?",
      answer:
        "Basic KYC documents like Aadhaar, PAN card, bank statements or income proof are required. Exact paperwork depends on the loan type and profile.",
    },

    {
      question: "Can I prepay or close my loan early without penalty?",
      answer:
        "Yes, Shubh Paisa allows early closure / prepayment options. Charges depend on the loan plan you select, but many plans allow penalty-free closure.",
    },

    {
      question: "Is my data safe with Shubh Paisa?",
      answer:
        "Absolutely! We follow industry-standard data encryption and secure storage practices. Your personal and financial information stays protected.",
    },

    {
      question: "How do I get started with Shubh Paisa?",
      answer:
        "Simply apply online, submit your KYC, choose your loan plan, and complete verification. Our team assists if needed. You can get started in just a few minutes!",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ background: "#ffffff" }}
    >
      <div className="row">
       <div className="col-lg-2 d-none d-lg-block"></div>
        <div className="col-12 col-lg-8 px-3 px-md-4">
          <h2 className="text-center text-black mt-4 mb-5">
            Frequently Asked Questions
          </h2>

          <div className="row ">
            <div className="col-12">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <div
                    key={index}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      background: isOpen
                        ? "linear-gradient(90deg, #EAF3FF 0%, #FFFFFF 100%)"
                        : "#EDF3FC",
                      borderRadius: "12px",
                      padding: "18px 22px",
                      marginBottom: "14px",
                      cursor: "pointer",
                      boxShadow: "0px 1px 4px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          color: isOpen ? "#2B66F6" : "#667085",
                          fontWeight: isOpen ? "600" : "400",
                        }}
                      >
                        {faq.question}
                      </p>

                      {isOpen ? (
                        <FiChevronUp size={20} color="#2B66F6" />
                      ) : (
                        <FiChevronDown size={20} />
                      )}
                    </div>

                    {isOpen && (
                      <p
                        style={{
                          fontSize: "15px",
                          color: "#6F7D98",
                          marginTop: "10px",
                          lineHeight: "1.5",
                        }}
                      >
                        {faq.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      <div className="col-lg-2 d-none d-lg-block"></div>
      </div>
    </div>
  );
};

export default FaQ;
